export const ESSENTIALS = "";
export const ANALYTICS = "analytics";
export const APPEALS = "appeals";
